import { render, staticRenderFns } from "./CategoryTitle.vue?vue&type=template&id=654e26a5"
import script from "./CategoryTitle.vue?vue&type=script&lang=js"
export * from "./CategoryTitle.vue?vue&type=script&lang=js"
import style0 from "./CategoryTitle.vue?vue&type=style&index=0&id=654e26a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports